import {
  Navigation,
  RequiredDashboardData,
} from "@nju/feature-portal-dashboard";
import { Footer } from "@nju/feature-portal-footer";
import { Header } from "@nju/feature-portal-header";
import { ReactivationSuccessPage } from "@nju/feature-portal-service";
import { BlockContent, LayoutWrapper } from "@nju/ui";

export default function ReactivationSuccess() {
  return (
    <LayoutWrapper>
      <Header />
      <BlockContent grid="narrow" spacing="xl" tone="primary">
        <RequiredDashboardData extendedMode="base">
          <Navigation title="moja usługa" />
          <ReactivationSuccessPage />
        </RequiredDashboardData>
      </BlockContent>
      <Footer />
    </LayoutWrapper>
  );
}
